import contactSideBarFields from 'molecules/ContactSideBar/config';

import type { Input } from '@builder.io/sdk';

const contactFormFields = [
  {
    name: 'title',
    type: 'string',
  },
  {
    name: 'formId',
    type: 'string',
  },
  {
    name: 'outline',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'addPadding',
    type: 'boolean',
    defaultValue: 'false',
  },
  {
    name: 'formFields',
    type: 'list',
    subFields: [
      {
        name: 'type',
        type: 'string',
        enum: ['text', 'email', 'textarea', 'state', 'tel', 'select', 'radio', 'checkbox'],
        defaultValue: 'text',
      },
      {
        name: 'fieldName',
        type: 'string',
      },
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'required',
        type: 'boolean',
        defaultValue: false,
      },
      {
        name: 'options',
        type: 'list',
        showIf: "options.get('type') === 'select' || options.get('type') === 'radio'",
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
        ],
      },
    ],
  },
  {
    name: 'redirect_url',
    type: 'object',
    subFields: [
      {
        name: 'dev_url',
        friendlyName: 'dev',
        type: 'string',
      },
      {
        name: 'qa_url',
        friendlyName: 'qa',
        type: 'string',
      },
      {
        name: 'staging_url',
        friendlyName: 'uat',
        type: 'url',
      },
      {
        name: 'production_url',
        friendlyName: 'production',
        type: 'url',
      },
    ],
  },
  {
    name: 'contactSideBar',
    type: 'object',
    subFields: [...contactSideBarFields],
  },
] as const satisfies DeepReadonly<Input[]>;

const contactFormConfig = {
  name: 'Contact Form',
  inputs: contactFormFields,
};

export type ContactFormProps = GenerateBuilder<typeof contactFormFields>;

export default contactFormConfig;
